import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import Button from '../../components/Button';
import DestinationFromTo from '../../components/DestinationFromTo';
import Loader from '../../components/Loader';
import NotFound from '../../components/NotFound';
import TravelRow, { dataProps } from '../../components/TravelRow';
import { getProp, __ } from '../../utilities';
import { setStep } from '../App/actions';
import {
  enterStationsIsFetchingSelector,
  toStationsIsFetchingSelector,
} from '../ConnectionForm/selectors';
import {
  fetchConnectionFromTo,
  fetchDetail,
  fetchNextConnections,
  fetchPrevConnections,
  setOpenedDetail,
  setSorter,
} from './actions';
import {
  connectionByIdSelector,
  connectionDetailIsFetchingSelector,
  connectionDetailSelector,
  connectionIsFetchingSlector,
  connectionsObjectByDateSelector,
  dateOfFirstWaySelector,
  getSorterParamsSelector,
  isFetchingNextSelector,
  isFetchingPrevSelector,
  nextConnectionDateSelector,
  paramsSelector,
  prevConnectionDateSelector,
} from './selectors';

const LoaderWrapperNext = styled.div`
  margin: ${rem(10)} 0;
`;

const Wrapper = styled.div`
  padding: 2rem;
  @media screen and (max-width: 486px) {
    padding: 0.5rem;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.875rem;
`;

const ConnectionDate = styled.div`
  background-color: #fff;
  padding: ${rem(20)};
  padding-left: ${rem(35)};
  font-size: ${rem(18)};
  letter-spacing: -${rem(1)};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  color: #8e8e8e;
  border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.delimiter};
`;

const ConnectionsWrapperRows = styled.div`
  display: flex;
  flex-direction: column;
`;

const FromToWrapper = styled.div``;

const ConnectionsWrapper = styled.div``;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${rem(40)};
`;

const Title = styled.div`
  margin: 0 0 2rem 0;
  padding: 1rem 0;
  text-align: center;
`;

const NotFoundWrapper = styled.div``;

const NumberOfDay = styled.div`
  font-size: ${rem(22)};
  font-weight: 500;
`;

const Month = styled.div`
  font-size: ${rem(14)};
  text-transform: uppercase;
`;

const ConnectionByDateWrapper = styled.div`
  background: #f7f7f7;
  margin-bottom: ${rem(30)};
`;

class Connections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSorterOpened: false,
      selectedRow: null,
    };

    this.renderRow = this.renderRow.bind(this);
    this.handleToggleRow = this.handleToggleRow.bind(this);
    this.handleSelectSorter = this.handleSelectSorter.bind(this);
    this.toggleSorter = this.toggleSorter.bind(this);
    this.handleClickNext = this.handleClickNext.bind(this);
    this.visibilityOfContent = this.visibilityOfContent.bind(this);
    this.handleCloseRow = this.handleCloseRow.bind(this);
    this.handleClickNextConnections = this.handleClickNextConnections.bind(
      this,
    );
    this.handleClickPrevConnections = this.handleClickPrevConnections.bind(
      this,
    );
  }

  componentWillMount() {
    this.setState({
      selectedRow: null,
    });
    if (this.props.way === 2) {
      this.props.dispatch(
        fetchConnectionFromTo({
          ticketType: 'R',
          startDate: moment(
            getProp(this.props, ['location', 'query', 'endDate']),
          ),
          endDate: moment(
            getProp(this.props, ['location', 'query', 'endDate']),
          ).add('7', 'days'),
          stationTo: getProp(this.props, ['location', 'query', 'stationTo']),
          stationFrom: getProp(this.props, [
            'location',
            'query',
            'stationFrom',
          ]),
        }),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const { way, isFetchingConnection } = this.props;
    const {
      way: nextWay,
      isFetchingConnection: nextIsFetchingConnection,
    } = nextProps;
    if (way !== nextWay) {
      this.setState({
        selectedRow: null,
      });
    }
    if (isFetchingConnection !== nextIsFetchingConnection) {
      this.setState({
        selectedRow: null,
      });
    }
  }

  handleCloseRow() {
    this.setState({
      selectedRow: null,
    });
  }

  handleClickNextConnections(e) {
    e.preventDefault();
    this.props.dispatch(fetchNextConnections(this.props.nextConnectionDate));
  }

  handleClickPrevConnections(e) {
    e.preventDefault();
    this.props.dispatch(
      fetchPrevConnections(this.props.prevConnectionDate, this.props.way),
    );
  }

  visibilityOfContent() {
    this.setState({
      selectedRow: null,
    });
  }

  toggleSorter() {
    this.setState({ isSorterOpened: !this.state.isSorterOpened });
  }

  handleSelectSorter(sortBy) {
    this.setState({ isSorterOpened: false });
    this.props.dispatch(setSorter(sortBy));
  }

  isSeatingInConnection(id) {
    const sectors = getProp(this.props.connectionsById, [id, 'sectors'], []);
    let isSeating = false;
    sectors.forEach(sector => {
      if (sector.seating) {
        isSeating = true;
      }
    });
    return isSeating;
  }

  handleToggleRow(index, sectorsIds, connectionId) {
    if (this.state.selectedRow !== connectionId) {
      this.props.dispatch(setOpenedDetail(connectionId));
      sectorsIds.forEach(stop => {
        this.props.dispatch(
          fetchDetail(stop.id, stop.from, stop.to, connectionId),
        );
      });
      this.setState({ selectedRow: connectionId });
    } else {
      this.props.dispatch(setOpenedDetail(null));
      this.setState({ selectedRow: null });
    }
  }

  handleClickNext(connectionId) {
    const { paramsBus: { ticketType }, way } = this.props;
    if (ticketType === 'B') {
      const isSeating = this.isSeatingInConnection(connectionId);
      if (isSeating) {
        this.props.dispatch(
          setStep('reservations', {
            for: 'firstWay',
            info: { connectionId },
          }),
        );
      } else {
        this.props.dispatch(
          setStep('summary', {
            for: 'firstWay',
            info: { connectionId },
          }),
        );
      }
    } else if (way === 1) {
      if (ticketType === 'R') {
        this.props.dispatch(
          setStep('secondWay', {
            for: 'firstWay',
            info: { connectionId },
          }),
        );
      } else {
        this.props.dispatch(
          setStep('login', {
            for: 'firstWay',
            info: { connectionId },
          }),
        );
      }
    } else {
      this.props.dispatch(
        setStep('login', {
          for: 'secondWay',
          info: { connectionId },
        }),
      );
    }
  }

  renderRow(item, index) {
    const { paramsBus: { from, ticketType, to, count } } = this.props;
    return (
      <TravelRow
        key={index.toString()}
        way1Date={
          this.props.way === 1
            ? moment().format()
            : getProp(this.props, ['firstWayDate'])
        }
        ticketType={ticketType}
        data={item}
        from={this.props.way === 1 ? from.label : to.label}
        to={this.props.way === 1 ? to.label : from.label}
        count={count}
        selected={item.id_connect === this.state.selectedRow}
        onClick={this.handleToggleRow}
        onClose={this.handleCloseRow}
        onClickNext={this.handleClickNext}
        index={index}
        connectionDetail={this.props.connectionDetail}
        isFetching={this.props.isFetchingConnectionDetail}
      />
    );
  }

  renderConnections() {
    const {
      isFetchingConnection,
      connectionsByDate,
      paramsBus: { from, to, ticketType },
      prevConnectionDate,
      nextConnectionDate,
    } = this.props;

    let title = '';
    if (ticketType === 'B') {
      title = __('Spiatočná cesta');
    } else if (this.props.way === 1) {
      title = __('Prvá cesta');
    } else if (this.props.way === 2) {
      title = __('Druhá cesta');
    }

    return (
      <React.Fragment>
        {Object.keys(connectionsByDate).length > 0 || isFetchingConnection ? (
          <React.Fragment>
            <FromToWrapper>
              {this.props.way === 1 ? (
                <DestinationFromTo from={from.label} to={to.label} />
              ) : (
                <DestinationFromTo from={to.label} to={from.label} />
              )}
            </FromToWrapper>
            <Title>{title}</Title>
            <ConnectionsWrapper>
              {isFetchingConnection ? (
                <LoaderWrapper>
                  <Loader
                    size="xxl"
                    text={__('Vyhľadávame pre Vás najlepšie spojenia')}
                  />
                </LoaderWrapper>
              ) : (
                <React.Fragment>
                  {this.props.isFetchingPrevConnections ? (
                    <LoaderWrapperNext>
                      <Loader
                        size="xl"
                        text={__('Načítavajú sa predchádzajúce spojenia.')}
                      />
                    </LoaderWrapperNext>
                  ) : (
                    prevConnectionDate && (
                      <ButtonWrapper>
                        <Button
                          primary
                          onClick={this.handleClickPrevConnections}
                        >
                          {__('Predchádzajúce spojenia')}
                        </Button>
                      </ButtonWrapper>
                    )
                  )}
                  {Object.keys(connectionsByDate).map(date => {
                    const momentObject = moment(date);
                    return (
                      <ConnectionByDateWrapper key={date}>
                        <ConnectionDate>
                          <NumberOfDay>{momentObject.format('DD')}</NumberOfDay>
                          <Month>{momentObject.format('MMMM')}</Month>
                        </ConnectionDate>
                        <ConnectionsWrapperRows>
                          {connectionsByDate[date].map(this.renderRow)}
                        </ConnectionsWrapperRows>
                      </ConnectionByDateWrapper>
                    );
                  })}

                  {this.props.isFetchingNextConnections ? (
                    <LoaderWrapperNext>
                      <Loader
                        size="xl"
                        text={__('Načítavajú sa nasledujúce spojenia')}
                      />
                    </LoaderWrapperNext>
                  ) : (
                    nextConnectionDate && (
                      <ButtonWrapper>
                        <Button
                          primary
                          onClick={this.handleClickNextConnections}
                        >
                          {__('Nasledujúce spojenia')}
                        </Button>
                      </ButtonWrapper>
                    )
                  )}
                </React.Fragment>
              )}
            </ConnectionsWrapper>
          </React.Fragment>
        ) : (
          <NotFoundWrapper>
            <FromToWrapper>
              <DestinationFromTo from={from.label} to={to.label} />
            </FromToWrapper>
            <Title>{__('Prvá cesta')}</Title>
            <NotFound
              icon="bus"
              title={__('Pre zvolené hodnoty sa nenašli žiadne spojenia')}
            />
          </NotFoundWrapper>
        )}
      </React.Fragment>
    );
  }

  renderNotLoaded() {
    const { isFetchingEntryStations, isFetchingToStation } = this.props;
    const isFetchingStations = isFetchingEntryStations || isFetchingToStation;
    return isFetchingStations ? (
      <LoaderWrapper>
        <Loader size="xxl" text={__('Načítavajú sa zastávky')} />
      </LoaderWrapper>
    ) : (
      <NotFound icon="bus" title={__('Sme pripravení, môžete vyhľadávať')} />
    );
  }

  render() {
    const { paramsBus: { from, to, count } } = this.props;
    return (
      <Wrapper>
        {from && to && count
          ? this.renderConnections()
          : this.renderNotLoaded()}
      </Wrapper>
    );
  }
}

Connections.propTypes = {
  isFetchingEntryStations: PropTypes.bool,
  isFetchingToStation: PropTypes.bool,
  isFetchingNextConnections: PropTypes.bool,
  isFetchingPrevConnections: PropTypes.bool,
  isFetchingConnection: PropTypes.bool,
  connections: PropTypes.arrayOf(
    PropTypes.shape({
      ...dataProps,
    }),
  ),
  paramsBus: PropTypes.shape({
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    from: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
    to: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
    ticketType: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  isFetchingConnectionDetail: PropTypes.bool.isRequired,
  connectionDetail: PropTypes.shape({}),
  way: PropTypes.number.isRequired,
};

Connections.defaultProps = {
  isFetchingEntryStations: false,
  isFetchingToStation: false,
  isFetchingPrevConnections: false,
  isFetchingNextConnections: false,
  isFetchingConnection: true,
  connections: [],
  connectionDetail: {},
};

const mapStateToProps = (state, props) => {
  return {
    isFetchingEntryStations: enterStationsIsFetchingSelector(state),
    isFetchingToStation: toStationsIsFetchingSelector(state),
    isFetchingConnection: connectionIsFetchingSlector(state),
    paramsBus: paramsSelector(state),
    connectionsByDate: connectionsObjectByDateSelector(props.way)(state),
    nextConnectionDate: nextConnectionDateSelector(props.way)(state),
    prevConnectionDate: prevConnectionDateSelector(props.way)(state),
    selectedSorter: getSorterParamsSelector(state),
    connectionDetail: connectionDetailSelector(state),
    connectionsById: connectionByIdSelector(state),
    isFetchingConnectionDetail: connectionDetailIsFetchingSelector(state),
    isFetchingNextConnections: isFetchingNextSelector(state),
    isFetchingPrevConnections: isFetchingPrevSelector(state),
    firstWayDate: dateOfFirstWaySelector(state),
  };
};
const connectionsWithRouter = withRouter(Connections);
export default connect(mapStateToProps)(connectionsWithRouter);



// WEBPACK FOOTER //
// ./src/containers/Connections/index.js